@if (loader.requestsPending()) {
  <mat-progress-bar class="fixed" mode="indeterminate" color="primary"></mat-progress-bar>
}
<sds-theme-handler></sds-theme-handler>
